export interface Comic {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  cover: string;
  author: string;
  status: string;
  rating: number;
  popularity: number;
  views: string;
  latestChapter: string;
  description: string;
  tags: string[];
  featured?: boolean;
}

export const categories = [
  { id: "all", name: "全部" },
  { id: "reman", name: "热血" },
  { id: "love", name: "恋爱" },
  { id: "fantasy", name: "奇幻" },
  { id: "mystery", name: "悬疑" },
  { id: "comedy", name: "搞笑" },
  { id: "scifi", name: "科幻" },
  { id: "campus", name: "校园" },
  { id: "horror", name: "恐怖" },
  { id: "heal", name: "治愈" },
  { id: "sports", name: "运动" },
];

export const comics: Comic[] = [
  {
    id: "yanlong-zhanshi",
    title: "炎龙战士",
    category: "reman",
    categoryName: "热血",
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20fierce%20young%20warrior%20with%20blazing%20fire%20dragon%20wings%2C%20orange%20and%20red%20flame%20energy%2C%20dynamic%20action%20pose%2C%20dramatic%20dark%20background%20with%20ember%20particles%2C%20high%20detail%20cel%20shading%2C%20bold%20manga%20style%20illustration%2C%20clean%20composition&width=560&height=780&seq=manga-cover-01&orientation=portrait",
    author: "夜风",
    status: "连载中",
    rating: 9.2,
    popularity: 985000,
    views: "9.8亿",
    latestChapter: "第 328 话 · 火焰之心",
    description: "少年炎霄在火龙谷觉醒先祖之力，背负守护人界的使命踏上征途。当他挥舞燃烧的巨剑迎向魔潮，一场跨越千年的宿命之战就此展开。",
    tags: ["热血", "战斗", "奇幻", "冒险"],
    featured: true,
  },
  {
    id: "yueguang-jiaxiang",
    title: "月光下的约定",
    category: "love",
    categoryName: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20cover%20of%20a%20boy%20and%20girl%20under%20a%20large%20glowing%20moon%2C%20soft%20warm%20night%20sky%20with%20stars%20and%20cherry%20blossoms%2C%20tender%20expression%2C%20pastel%20pink%20and%20indigo%20palette%2C%20sweet%20youth%20romance%20illustration%2C%20high%20detail%20anime%20artwork&width=560&height=780&seq=manga-cover-02&orientation=portrait",
    author: "小满",
    status: "连载中",
    rating: 9.5,
    popularity: 872000,
    views: "7.2亿",
    latestChapter: "第 156 话 · 心跳的瞬间",
    description: "高三女生林晚月在图书馆偶遇转学生陆川，两个孤独的灵魂在月光下许下约定。青春的悸动、青涩的心跳，一部温柔细腻的校园恋爱物语。",
    tags: ["恋爱", "校园", "青春", "治愈"],
    featured: true,
  },
  {
    id: "lingjing-daomen",
    title: "灵境道门",
    category: "fantasy",
    categoryName: "奇幻",
    cover: "https://readdy.ai/api/search-image?query=Mystical%20anime%20manga%20cover%20of%20a%20taoist%20practitioner%20holding%20a%20glowing%20spirit%20sword%20amid%20floating%20mountains%20and%20mist%2C%20jade%20green%20and%20gold%20energy%20aesthetic%2C%20cultivation%20fantasy%20world%2C%20detailed%20ink%20style%20background%2C%20epic%20high%20fantasy%20illustration&width=560&height=780&seq=manga-cover-03&orientation=portrait",
    author: "青山",
    status: "连载中",
    rating: 8.8,
    popularity: 640000,
    views: "5.4亿",
    latestChapter: "第 214 话 · 天门开",
    description: "平凡少年误入灵境道门，从此踏入修仙问道之路。斩妖除魔、参悟天道，在波澜壮阔的东方奇幻世界里书写属于自己的传奇。",
    tags: ["奇幻", "修仙", "冒险", "东方"],
    featured: true,
  },
  {
    id: "wusheng-dangan",
    title: "无声档案",
    category: "mystery",
    categoryName: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Dark%20mystery%20anime%20manga%20cover%20of%20a%20detective%20silhouette%20holding%20a%20red%20file%20folder%20in%20dim%20moody%20lighting%2C%20shadowy%20city%20street%20at%20night%2C%20suspenseful%20teal%20and%20crimson%20tones%2C%20film%20noir%20atmosphere%2C%20intricate%20illustration&width=560&height=780&seq=manga-cover-04&orientation=portrait",
    author: "迷雾",
    status: "已完结",
    rating: 9.0,
    popularity: 560000,
    views: "4.9亿",
    latestChapter: "第 98 话 · 真相大白",
    description: "刑侦队长沈默接手一桩看似普通的失踪案，却牵出横跨十年的连环谜局。每一页都藏着线索，真相在无声处等待被听见。",
    tags: ["悬疑", "推理", "刑侦", "智斗"],
  },
  {
    id: "qimiao-riji",
    title: "奇妙日常",
    category: "comedy",
    categoryName: "搞笑",
    cover: "https://readdy.ai/api/search-image?query=Funny%20comedy%20anime%20manga%20cover%20with%20colorful%20kawaii%20characters%20making%20silly%20faces%20and%20slapstick%20poses%2C%20bright%20playful%20yellow%20and%20teal%20background%20with%20comic%20speed%20lines%2C%20chibi%20style%20comedy%20illustration%2C%20lighthearted%20and%20energetic&width=560&height=780&seq=manga-cover-05&orientation=portrait",
    author: "豆丁",
    status: "连载中",
    rating: 8.6,
    popularity: 490000,
    views: "4.1亿",
    latestChapter: "第 245 话 · 厨房大作战",
    description: "中二少年和猫系室友的爆笑合租日常。鸡飞狗跳的每一天，笑点密集到根本停不下来，适合放松时刷上几话的治愈喜剧。",
    tags: ["搞笑", "日常", "治愈", "单元剧"],
  },
  {
    id: "xingji-tansuo",
    title: "星际探索者",
    category: "scifi",
    categoryName: "科幻",
    cover: "https://readdy.ai/api/search-image?query=Futuristic%20sci%20fi%20anime%20manga%20cover%20of%20an%20astronaut%20explorer%20standing%20on%20a%20distant%20planet%20with%20two%20moons%2C%20starship%20in%20background%2C%20vivid%20purple%20nebula%20and%20orange%20planet%20skies%2C%20epic%20space%20exploration%20illustration%2C%20high%20detail%20sci%20fi%20artwork&width=560&height=780&seq=manga-cover-06&orientation=portrait",
    author: "星河",
    status: "连载中",
    rating: 8.9,
    popularity: 530000,
    views: "4.5亿",
    latestChapter: "第 187 话 · 未知信号",
    description: "公元 2387 年，人类探测器在比邻星系接收到神秘信号。年轻的女舰长带领船员踏上星际远征，揭开宇宙深处的秘密。",
    tags: ["科幻", "太空", "冒险", "未来"],
  },
  {
    id: "sakura-xiaoyuan",
    title: "樱花校园",
    category: "campus",
    categoryName: "校园",
    cover: "https://readdy.ai/api/search-image?query=School%20anime%20manga%20cover%20of%20high%20school%20students%20in%20uniforms%20walking%20under%20blooming%20sakura%20trees%2C%20bright%20sunny%20campus%20background%2C%20soft%20pink%20and%20white%20palette%2C%20youthful%20coming%20of%20age%20illustration%2C%20clean%20manga%20style&width=560&height=780&seq=manga-cover-07&orientation=portrait",
    author: "柠檬",
    status: "连载中",
    rating: 8.7,
    popularity: 470000,
    views: "3.8亿",
    latestChapter: "第 132 话 · 社团活动",
    description: "普通高中生苏妍加入摄影社，在樱花纷飞的校园里遇见了一群有趣的朋友。青春、友情与梦想，在平凡日常中闪闪发光。",
    tags: ["校园", "青春", "友情", "治愈"],
  },
  {
    id: "yejian-ying",
    title: "夜间低语",
    category: "horror",
    categoryName: "恐怖",
    cover: "https://readdy.ai/api/search-image?query=Horror%20anime%20manga%20cover%20of%20an%20old%20haunted%20house%20at%20night%20with%20fog%20and%20a%20lone%20figure%20at%20the%20window%2C%20pale%20blue%20moonlight%2C%20creepy%20atmosphere%2C%20dark%20shadowy%20tones%2C%20thriller%20horror%20illustration%2C%20moody%20and%20eerie&width=560&height=780&seq=manga-cover-08&orientation=portrait",
    author: "暗夜",
    status: "已完结",
    rating: 8.4,
    popularity: 380000,
    views: "3.0亿",
    latestChapter: "第 76 话 · 黎明",
    description: "深夜的旧宅传来若有若无的低语，年轻的撰稿人决定搬进去寻找真相。越接近真相，越发现自己也是故事的一部分。",
    tags: ["恐怖", "灵异", "悬疑", "心理"],
  },
  {
    id: "nuanxin-xiaozhan",
    title: "暖心小站",
    category: "heal",
    categoryName: "治愈",
    cover: "https://readdy.ai/api/search-image?query=Wholesome%20healing%20anime%20manga%20cover%20of%20a%20cozy%20small%20train%20station%20cafe%20with%20warm%20lighting%20and%20a%20smiling%20barista%20serving%20tea%2C%20soft%20muted%20warm%20palette%2C%20gentle%20peaceful%20atmosphere%2C%20comforting%20slice%20of%20life%20illustration&width=560&height=780&seq=manga-cover-09&orientation=portrait",
    author: "暖阳",
    status: "连载中",
    rating: 9.3,
    popularity: 520000,
    views: "4.4亿",
    latestChapter: "第 168 话 · 一碗热汤",
    description: "小镇尽头有一间从不打烊的暖心小站，往来的旅人在这里卸下疲惫。每一话都是一则治愈人心的温暖故事。",
    tags: ["治愈", "日常", "温暖", "单元剧"],
    featured: true,
  },
  {
    id: "feitiao-shaonian",
    title: "飞跳少年",
    category: "sports",
    categoryName: "运动",
    cover: "https://readdy.ai/api/search-image?query=Sports%20anime%20manga%20cover%20of%20a%20basketball%20player%20mid%20dunk%20jump%20with%20dynamic%20motion%20lines%2C%20court%20lights%20in%20background%2C%20orange%20and%20navy%20energetic%20palette%2C%20competitive%20sports%20illustration%2C%20action%20packed%20manga%20artwork&width=560&height=780&seq=manga-cover-10&orientation=portrait",
    author: "灌篮",
    status: "连载中",
    rating: 8.8,
    popularity: 430000,
    views: "3.6亿",
    latestChapter: "第 201 话 · 加时赛",
    description: "矮个子少年徐飞坚信热爱可以跨越身高的差距，在高中篮球场上拼尽全力。汗水、呐喊与友情，一部燃烧的运动热血漫画。",
    tags: ["运动", "热血", "青春", "篮球"],
  },
  {
    id: "longzhan-tiandi",
    title: "龙战天地",
    category: "reman",
    categoryName: "热血",
    cover: "https://readdy.ai/api/search-image?query=Epic%20anime%20manga%20cover%20of%20a%20hero%20facing%20a%20giant%20ancient%20dragon%20on%20a%20cliff%2C%20stormy%20sky%20with%20lightning%2C%20golden%20and%20crimson%20epic%20palette%2C%20high%20fantasy%20battle%20illustration%2C%20heroic%20pose%2C%20high%20detail%20manga%20artwork&width=560&height=780&seq=manga-cover-11&orientation=portrait",
    author: "战歌",
    status: "连载中",
    rating: 9.1,
    popularity: 610000,
    views: "5.1亿",
    latestChapter: "第 189 话 · 龙血沸腾",
    description: "当巨龙再度降临人间，背负封印的少年剑客与群龙展开生死对决。守护与燃烧，一部酣畅淋漓的史诗级热血战斗漫画。",
    tags: ["热血", "战斗", "奇幻", "史诗"],
    featured: true,
  },
  {
    id: "aiqing-xiaoming",
    title: "爱情小径",
    category: "love",
    categoryName: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Sweet%20romance%20anime%20manga%20cover%20of%20a%20couple%20walking%20along%20a%20flower%20path%20holding%20hands%20at%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20soft%20romantic%20atmosphere%2C%20blooming%20flowers%20background%2C%20cute%20anime%20style%20illustration&width=560&height=780&seq=manga-cover-12&orientation=portrait",
    author: "糖霜",
    status: "连载中",
    rating: 8.9,
    popularity: 450000,
    views: "3.9亿",
    latestChapter: "第 92 话 · 告白",
    description: "两条平行线般的相遇，在命运的小径上渐渐交叠。细腻的情感刻画，让每一格都充满心跳的恋爱轻喜剧。",
    tags: ["恋爱", "轻喜剧", "青春", "甜蜜"],
  },
];